export enum AzureSignInMethodEnum {
    Redirect = 'redirect',
    Popup = 'popup',
    Silent = 'silent',
    None = 'none',
}
